import { Session } from "@mezo/api"
import { PayloadAction } from "@reduxjs/toolkit"

import { AccountCreationStatus } from "#/shared/types"
import { isSameAddress } from "#/shared/utils"

import createDappAsyncThunk from "../asyncThunk"
import { setAccountCreationStatus } from "../slices/account"

export const getSession = createDappAsyncThunk(
  "session/getSession",
  async (
    { requestNewSession }: { requestNewSession?: boolean },
    { extra: { sdk } },
  ): Promise<Session | null> => {
    const session = await sdk.mezo.api.session.getSession(requestNewSession)
    if (!session) return null

    return session
  },
)

// This should be used as an endpoint
export const createSession = createDappAsyncThunk(
  "session/createSession",
  async (_, { dispatch, getState }) => {
    let session: Session | null = null
    const { address } = getState().wallet

    if (!address) return false
    ;({ payload: session } = (await dispatch(
      getSession({ requestNewSession: false }),
    )) as PayloadAction<Session | null>)

    if (!session) return false // Backend doesn't recognize this account

    // Session already created for this account
    if ("address" in session && isSameAddress(address, session.address)) {
      dispatch(setAccountCreationStatus(AccountCreationStatus.Created))
      return true
    }

    // Session created for another account
    if ("address" in session && !isSameAddress(address, session.address)) {
      // Send the request without a cookie to get a new nonce - create a fresh session
      ;({ payload: session } = (await dispatch(
        getSession({ requestNewSession: true }),
      )) as PayloadAction<Session | null>)
    }

    if (!session || !("nonce" in session)) {
      dispatch(setAccountCreationStatus(AccountCreationStatus.NotSigned))
      return false
    }

    dispatch(setAccountCreationStatus(AccountCreationStatus.Created))
    return true
  },
)
